export class EnderecoAdministrativoDTO {
  cep?: string;
  logradouro?: string;
  numero?: string;
  complemento?: string;
  bairro?: string;
  cidade?: string;
  estado?: string;
  tipo?: string;
  constructor(
    cep?: string,
    logradouro?: string,
    bairro?: string,
    cidade?: string,
    estado?: string,
    tipo?: string,
    numero?: string,
    complemento?: string,
  ) {
    this.cep = cep;
    this.logradouro = logradouro;
    this.numero = numero;
    this.complemento = complemento;
    this.bairro = bairro;
    this.cidade = cidade;
    this.estado = estado;
    this.tipo = tipo
  }
}
